import { Box, Divider, Typography, useTheme, Grid } from "@mui/material";
import Glass from "./glass/glass";
import { useSelector } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import UIIcon from './ui-icon';
import type { RootState } from '../types/store';

export default function GameInfo({ ...props }) {
    const theme = useTheme();
    const translate = useSelector((state: RootState) => state.ui.language);
    const settings = useSelector((state: RootState) => state.settings);
    const lobby = useSelector((state: RootState) => state.page.lobby);
    const isTV = !lobby.playing;

    const icons = translate.icons.flatMap((icon, index: number) => {
        const icon_data = settings.icons[index];
        if (icon_data && icon_data.icon !== undefined) {
            return [{ icon: icon_data.icon, color: icon_data.color, name: icon.name, description: icon.description }];
        }
        return [];
    });

    const categories = lobby.categories.flatMap((category) => {
        const match = translate.categories.find((c) => c.id === category);
        const match_settings = settings.categories.find((c) => c.id === category);
        if (match && match_settings) {
            return [{ id: category, icon: match_settings.icon, color: match_settings.color, name: match.name, description: match.description }];
        }
        return [];
    });

    return (
        <Glass sx={{ borderRadius: 1, marginTop: isTV ? 0 : 2, display: 'flex', flexDirection: 'column' }} {...props}>
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} borderRadius={1}
                color={theme.palette.primary.light} bgcolor={theme.palette.secondary.dark} padding={isTV ? 0.75 : 1} flexShrink={0}>
                <Typography fontSize={isTV ? "1.1rem" : "1.25rem"}>{translate.lobby.gameInfoHeader}</Typography>
            </Box>
            <Grid
                container
                spacing={isTV ? 1 : 2}
                padding={isTV ? 1.5 : 2}
                sx={{
                    overflowY: 'auto',
                    maxHeight: isTV ? 'calc(100dvh - 210px)' : 'none',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#7dabd0ff rgba(255,255,255,0.1)',
                    '&::-webkit-scrollbar': { width: '8px' },
                    '&::-webkit-scrollbar-thumb': { background: '#7dabd0ff', borderRadius: '4px' },
                    '&::-webkit-scrollbar-track': { background: 'rgba(255,255,255,0.1)' },
                }}
            >
                <Grid key={1} size={{ xs: 12 }}>
                    <center>
                        <QRCodeSVG size={isTV ? 100 : 128} value={`https://beta.moes.beer/join/${lobby.code}`} /><br />
                        <Typography color={theme.palette.primary.light} fontSize={isTV ? "0.9rem" : "1rem"}>{translate.lobby.joinAtOrQRCode}</Typography>
                    </center>
                </Grid>

                <Grid key={2} size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Typography color={theme.palette.primary.light} fontSize={isTV ? "1.1rem" : "1.25rem"}>{translate.lobby.iconsHeader}</Typography>
                    {icons.map((icon, i: number) => {
                        return (<Grid key={i} size={{ xs: 12 }} padding={isTV ? 0.5 : 1}>
                            <Typography fontSize={isTV ? "0.875rem" : "1rem"}><UIIcon icon={icon.icon} color={icon.color} />&nbsp;&nbsp;{icon.description}</Typography>
                            <Divider />
                        </Grid>);
                    })}
                </Grid>

                <Grid key={3} size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Typography color={theme.palette.primary.light} fontSize={isTV ? "1.1rem" : "1.25rem"}>{translate.lobby.categoriesHeader}</Typography>
                    {categories.map((c, i: number) => {
                        return (<Grid key={i} size={{ xs: 12 }} padding={isTV ? 0.5 : 1}>
                            <Typography fontSize={isTV ? "0.875rem" : "1rem"}><UIIcon icon={c.icon} color={c.color} />&nbsp;&nbsp;{c.name}</Typography>
                            <Divider />
                        </Grid>);
                    })}
                </Grid>

            </Grid>
        </Glass>
    );
}
